






















































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import publishObjectPath from '@/util/configRegistry';
import { performanceServer } from '@/api/installServer';
import RectifyInfoDialog from '@/views/inspectionContents/checklist/unit/rectifyInfoDialog.vue';

@Component({
  components: { RectifyInfoDialog },
})
export default class HazardDetail extends Vue {
  @Prop(Object) row!: any; // 从父组件接受过来一行的数据
  @Prop(String) pageType!: any; // 从父组件接受过来一行的数据

  scrollbar = true;
  formData: any = {};
  serverUrl: any = publishObjectPath.imgPathWater;

  private dialogVisible = false;
  private reviewFormData: any = {
    feedbackFormHazardId: '',
    reviewContent: '',
    reviewRemark: '',
    passFlag: true,
    rectifyExpiryDate: '',
    reviewExpiryDate: '',
    reviewPicture: '',
  };

  private reviewStatus: any = {
    0: '未复查',
    1: '已通过',
    2: '未通过',
  }; // 复查状态
  private levelText: any = {
    D: '一般隐患III级(D)',
    C: '一般隐患II级(C)',
    B: '一般隐患I级(B)',
    A: '重大隐患(A)',
  };
  private delayStatus: any = {
    1: '待审核',
    2: '已延期',
    3: '已驳回',
    4: '已取消',
  }; // 延期状态
  private auditVisible: any = false;
  private auditFormData: any = {
    applyDelayId: '',
    auditDelayOpinion: '',
    passFlag: false,
  };
  private auditLoading: any = false;
  auditFormRules: any = {
    auditDelayOpinion: [{ required: true, message: '请输入审核意见', trigger: 'blur' }],
  };

  fileList: any = [];
  headers: any = {};
  actionUrl: any = ''; // 图片上传

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    this.reviewFormData.reviewPicture = arr.toString();
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response.data) {
        arr.push(item.response.data[0].id);
      }
    });
    this.reviewFormData.reviewPicture = arr.toString(); // 存放选择的隐患图片
  }

  /**
   * @desc vue 创建数据生命周期,获取父组件传递过来那一行员工的数据。
   * @param1 无
   * @returns 无
   */
  created() {
    this.formData = this.row;
    this.$set(this.formData, 'hazardPictureFiles', []);
    this.$set(this.formData, 'rectifyPictureFiles', []);
    if (this.formData.hazardPicture) {
      performanceServer.getSysFile(this.formData.hazardPicture).then((res: any) => {
        if (res.code === '200' && res.data && res.data.length > 0) {
          this.formData.hazardPictureFiles = res.data;
        }
      });
    }
    if (this.formData.rectifyPicture) {
      performanceServer.getSysFile(this.formData.rectifyPicture).then((res: any) => {
        if (res.code === '200' && res.data && res.data.length > 0) {
          this.formData.rectifyPictureFiles = res.data;
        }
      });
    }
    this.reviewFormData.feedbackFormHazardId = this.row.id;
    console.log(this.formData, 'this.formData');
  }

  mounted() {
    this.hasScrollbar();
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * @desc 点击关闭按钮，清空内容并返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.$emit('hazardDetailResponse');
  }

  reviewForm() {
    this.dialogVisible = true;
  }
  closeDialog() {
    this.dialogVisible = false;
    this.reviewFormData = {
      feedbackFormHazardId: '',
      reviewContent: '',
      reviewRemark: '',
      passFlag: true,
      rectifyExpiryDate: '',
      reviewExpiryDate: '',
      reviewPicture: '',
    };
    this.fileList = [];
  }
  submitOrgan() {
    const formComponent: any = this.$refs['formDataRef'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      performanceServer
        .reviewHazard(this.reviewFormData)
        .then((res: any) => {
          if (res.code === '200') {
            this.$emit('hazardDetailResponse');
            this.closeDialog();
          } else {
            this.$message.warning(res.msg);
          }
        })
        .catch(() => {});
    });
  }
  showRectifyForm() {
    const sendData: any = {
      id: this.formData.hazardId,
      rectifyContent: this.formData.rectifyContent,
      rectifyTime: this.formData.rectifyTime,
      rectifyPicture: this.formData.rectifyPicture,
      rectifyRemark: this.formData.rectifyRemark,
    };
    (this.$refs.RectifyInfoDialog as any).showDialog(sendData);
  }
  refreshDetail() {
    this.$emit('hazardDetailResponse');
    this.closeDialog();
  }

  // 图片预览
  previewList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.serverUrl}${item.path}`);
    });
    return arr;
  }

  delayAuditForm() {
    this.auditFormData.applyDelayId = this.formData.id;
    this.auditVisible = true;
  }
  closeAuditDialog() {
    this.auditVisible = false;
    this.auditFormData = {
      applyDelayId: '',
      auditDelayOpinion: '',
      passFlag: false,
    };
    this.$nextTick(() => {
      (this.$refs.auditFormRef as any).clearValidate();
    });
  }
  submitAudit() {
    const formComponent: any = this.$refs['auditFormRef'];
    formComponent.validate((valid: any) => {
      if (!valid) return;
      this.auditLoading = true;
      performanceServer.auditDelay(this.auditFormData).then((res: any) => {
        if (res.code === '200') {
          this.auditLoading = false;
          this.$message.success('审核成功');
          this.$emit('hazardDetailResponse');
          this.closeAuditDialog();
        } else {
          this.$message.warning(res.msg);
          this.auditLoading = false;
        }
      });
    });
  }
}
